module.exports = __webpack_public_path__ + "img/pura.2c63dfcd.svg";